import{isObject as e}from"@guildeducationinc/type-guards";var n=function(n){return e(n)&&(!("_dependencies"in n)||e(n._dependencies))};export{n as hasDependencies};
